import { Routes, Route, Navigate } from 'react-router-dom'
import { useAuth } from './context/AuthContext'
import AppLayout from './components/layout/AppLayout'

import LoginPage           from './pages/LoginPage'
import RegisterPage        from './pages/RegisterPage'
import DashboardPage       from './pages/DashboardPage'
import VehiclesPage        from './pages/VehiclesPage'
import VehicleDetailPage   from './pages/VehicleDetailPage'
import ServiceSchedulePage from './pages/ServiceSchedulePage'
import IssuesPage          from './pages/IssuesPage'
import IssueDetailPage     from './pages/IssueDetailPage'
import QuotesPage          from './pages/QuotesPage'
import ServiceHistoryPage  from './pages/ServiceHistoryPage'
import GarageDashboardPage from './pages/GarageDashboardPage'
import JobsPage                from './pages/JobsPage'
import JobDetailPage          from './pages/JobDetailPage'
import CustomersPage          from './pages/CustomersPage'
import CustomerDetailPage     from './pages/CustomerDetailPage'
import GarageVehicleDetailPage from './pages/GarageVehicleDetailPage'
import PartsPage           from './pages/PartsPage'
import InvoicesPage        from './pages/InvoicesPage'
import RepairsPage         from './pages/RepairsPage'
import SettingsPage        from './pages/SettingsPage'
import AdminPage               from './pages/AdminPage'
import ReportsPage             from './pages/ReportsPage'
import EmailLogPage            from './pages/EmailLogPage'
import CheckinFormPage         from './pages/CheckinFormPage'
import CheckinTemplatesPage    from './pages/CheckinTemplatesPage'

function ProtectedRoute({ children, roles }) {
  const { user, loading } = useAuth()

  if (loading) {
    return (
      <div className="min-h-dvh flex items-center justify-center bg-[var(--bg-base)]">
        <div className="text-[var(--text-secondary)] text-sm">Loading…</div>
      </div>
    )
  }

  if (!user) return <Navigate to="/login" replace />

  if (roles && !roles.includes(user.role)) return <Navigate to="/" replace />

  return <AppLayout>{children}</AppLayout>
}

const GARAGE_ROLES = ['garage_user', 'garage_admin', 'platform_admin']

export default function App() {
  return (
    <Routes>
      {/* Public */}
      <Route path="/login"          element={<LoginPage />} />
      <Route path="/register"       element={<RegisterPage />} />
      <Route path="/checkin/:token" element={<CheckinFormPage />} />

      {/* Customer */}
      <Route path="/"           element={<ProtectedRoute><DashboardPage /></ProtectedRoute>} />
      <Route path="/vehicles"   element={<ProtectedRoute><VehiclesPage /></ProtectedRoute>} />
      <Route path="/vehicles/:id" element={<ProtectedRoute><VehicleDetailPage /></ProtectedRoute>} />
      <Route path="/schedule"   element={<ProtectedRoute><ServiceSchedulePage /></ProtectedRoute>} />
      <Route path="/issues"     element={<ProtectedRoute><IssuesPage /></ProtectedRoute>} />
      <Route path="/issues/:id" element={<ProtectedRoute><IssueDetailPage /></ProtectedRoute>} />
      <Route path="/quotes"      element={<ProtectedRoute><QuotesPage /></ProtectedRoute>} />
      <Route path="/repairs"     element={<ProtectedRoute><RepairsPage /></ProtectedRoute>} />
      <Route path="/repairs/:id" element={<ProtectedRoute><JobDetailPage /></ProtectedRoute>} />
      <Route path="/history"     element={<ProtectedRoute><ServiceHistoryPage /></ProtectedRoute>} />
      <Route path="/emails"      element={<ProtectedRoute><EmailLogPage /></ProtectedRoute>} />

      {/* Garage */}
      <Route path="/garage"                    element={<ProtectedRoute roles={GARAGE_ROLES}><GarageDashboardPage /></ProtectedRoute>} />
      <Route path="/garage/jobs"               element={<ProtectedRoute roles={GARAGE_ROLES}><JobsPage /></ProtectedRoute>} />
      <Route path="/garage/jobs/:id"           element={<ProtectedRoute roles={GARAGE_ROLES}><JobDetailPage /></ProtectedRoute>} />
      <Route path="/garage/customers"          element={<ProtectedRoute roles={GARAGE_ROLES}><CustomersPage /></ProtectedRoute>} />
      <Route path="/garage/customers/:id"      element={<ProtectedRoute roles={GARAGE_ROLES}><CustomerDetailPage /></ProtectedRoute>} />
      <Route path="/garage/vehicles/:id"       element={<ProtectedRoute roles={GARAGE_ROLES}><GarageVehicleDetailPage /></ProtectedRoute>} />
      <Route path="/garage/parts"              element={<ProtectedRoute roles={GARAGE_ROLES}><PartsPage /></ProtectedRoute>} />
      <Route path="/garage/quotes"             element={<ProtectedRoute roles={GARAGE_ROLES}><QuotesPage /></ProtectedRoute>} />
      <Route path="/garage/invoices"           element={<ProtectedRoute roles={GARAGE_ROLES}><InvoicesPage /></ProtectedRoute>} />
      <Route path="/garage/emails"            element={<ProtectedRoute roles={GARAGE_ROLES}><EmailLogPage /></ProtectedRoute>} />
      <Route path="/garage/checkins"          element={<ProtectedRoute roles={GARAGE_ROLES}><CheckinTemplatesPage /></ProtectedRoute>} />

      {/* Shared */}
      <Route path="/settings" element={<ProtectedRoute><SettingsPage /></ProtectedRoute>} />
      <Route path="/reports"  element={<ProtectedRoute><ReportsPage /></ProtectedRoute>} />

      {/* Admin */}
      <Route path="/admin" element={<ProtectedRoute roles={['platform_admin']}><AdminPage /></ProtectedRoute>} />

      {/* Fallback */}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  )
}
